import React, { FC } from 'react';
import useMediaQuery from '../../../lib/custom-hooks/useMediaQuery';
import Picture from '../../@shared/picture';
import VideoPlayer from '../../@shared/videoPlayer';
import { Breakpoints } from '../../../constants/breakpoints.constants';
import { iconSize } from '../../../constants/icon.constants';
import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { getImageField } from '../../../utils/getImageFields';
import { TNewsDetailMediaProps } from '../types/newsDetail.types';

const NewsDetailMedia: FC<TNewsDetailMediaProps> = ({ showVideo, desktopImage, mobileImage, video, isMediaExists }) => {
  const isDesktop = useMediaQuery(`(min-width: ${Breakpoints['md']}px)`);
  const videoUrl = video?.value?.href;

  if (!isMediaExists) {
    return null;
  }

  if (showVideo) {
    const { thumbnailImgSrc } = getThumbnailProps(videoUrl || '');
    const desktopImageOrThumbnail = getImageField(desktopImage, thumbnailImgSrc ?? '', showVideo);
    const mobileImageOrThumbnail = getImageField(mobileImage, thumbnailImgSrc ?? '', showVideo);

    return (
      <div className="news-detail__media-wrapper news-detail__media--video-wrapper">
        <VideoPlayer
          link={videoUrl}
          autoPlay={true}
          videoPlayerWrapperClassName="news-detail__media--video"
          showThumbnail={true}
          desktopPlayIconSize={iconSize.xlg}
          mobilePlayIconSize={iconSize.dsk}
          editorialImageProps={{
            mobileImage: mobileImageOrThumbnail,
            desktopImage: desktopImageOrThumbnail,
            isEditable: true,
            alt: (isDesktop ? desktopImageOrThumbnail?.value?.alt : mobileImageOrThumbnail?.value?.alt) as string,
          }}
        />
      </div>
    );
  }

  return (
    <Picture
      editorialImageProps={{
        desktopImage: desktopImage,
        mobileImage: mobileImage,
        desktopTransformation: 'Size1000',
        mobileTransformation: 'Size1000',
        cssClassPictureEl: 'news-detail__media--image',
      }}
    />
  );
};

export default NewsDetailMedia;
